import {TipoCFEDTO} from './TipoCFEDTO';

export class ReferenciaCFEDTO
{
  tipoCFE: TipoCFEDTO;
  serie: string;
  numero: number;
  fechaEmision: Date;

  public limpiar(): void
  {
    this.tipoCFE = null;
    this.serie = null;
    this.numero = null;
    this.fechaEmision = null;
  }
}
